import React from 'react'
import './Footer.css';

import logoMinistere from '../assets/ministere.png';
import logoAgenceDuSport from '../assets/agence_du_sport.png';
import logoCreditMutuel from '../assets/credit_mutuel.png';
import logoTibhar from '../assets/tibhar.png';
import leapmotor from '../assets/leapmotor.png';
import logoCornilleau from '../assets/cornilleau.png';
import logoDonic from '../assets/donic.png';
import logoGerflor from '../assets/gerflor.png';
import logoLequipe from '../assets/lequipe.png';

import { useTranslation } from '../i18n';
import { socialLinks } from './UponHeader';

// whiteBg : logo conservé en couleurs sur fond blanc (les autres sont passés en blanc)
const partenaires = [
    { src: logoMinistere, alt: 'Ministère des Sports', href: 'https://www.jeunes.gouv.fr/la-ministre-des-sports-de-la-jeunesse-et-de-la-vie-associative-2437', whiteBg: true },
    { src: logoAgenceDuSport, alt: 'Agence du Sport', href: 'https://www.agencedusport.fr/' },
    { src: logoCreditMutuel, alt: 'Crédit Mutuel', href: 'https://www.creditmutuel.fr/home/index.html' },
    { src: logoTibhar, alt: 'Tibhar', href: 'https://tibhar.info/home/' },
    { src: leapmotor, alt: 'Leapmotor', href: 'https://www.leapmotor.net/fr' },
    { src: logoCornilleau, alt: 'Cornilleau', href: 'https://fr.cornilleau.com/' },
    { src: logoDonic, alt: 'Donic', href: 'https://www.donic.com/fr/' },
    { src: logoGerflor, alt: 'Gerflor', href: 'https://www.gerflor.fr/' },
    { src: logoLequipe, alt: "L'Équipe", href: 'https://www.lequipe.fr/' },
]

function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="footer_component">

            <div className="footer_flag">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className="footer_partenaires">
                <h2 className="footer_span_partenaires">{t('footer.partners')}</h2>
                <ul className="footer_logos_row">
                    {
                        partenaires.map((item) => (
                            <li key={item.alt}>
                                <a className="footer_logo_link" href={item.href} target="_blank" rel="noreferrer" title={item.alt}>
                                    <img className={item.whiteBg ? 'footer_logo_white_bg' : ''} src={item.src} alt={item.alt} loading="lazy" />
                                </a>
                            </li>
                        ))
                    }
                </ul>
                {/* Réseaux sociaux : le bandeau du haut est masqué en mobile, on les reprend ici */}
                <ul className="footer_social">
                    {
                        socialLinks.map((item) => (
                            <li key={item.label}>
                                <a href={item.href} target="_blank" rel="noreferrer" aria-label={item.label}>
                                    {item.icon}
                                </a>
                            </li>
                        ))
                    }
                </ul>
            </div>
            <section className="footer_links">
                <div className="footer_links_wrapper">
                    <ul className="footer_links_nav">
                        <li>
                            <a href="https://www.fftt.com/mentions-legales/" target="_blank" rel="noreferrer">{t('footer.legal')}</a>
                        </li>
                        <li>
                            <a href="https://www.fftt.com/contactez-nous/" target="_blank" rel="noreferrer">{t('footer.contact')}</a>
                        </li>
                    </ul>
                    <ul className="footer_links_mentions">
                        <li>© FFTT PRO {new Date().getFullYear()}</li>
                    </ul>
                </div>
            </section>
        </footer>
    );
}

export default Footer;
